var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category"},[_c('div',{staticClass:"category-list"},_vm._l((_vm.categoryList),function(category,key){return _c('div',{key:key,staticClass:"category-item",class:_vm.getClass(category),on:{"click":function($event){return _vm.onCategory(category)}}},[_vm._v(_vm._s(category.cidName))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }